import axios from "axios";

export default axios.create(
    {
        baseURL: "https://sapid-21ca2-default-rtdb.firebaseio.com/"
    }
)